import React, { useState, useEffect } from "react";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Spin,
  Space,
  Button,
  Input,
  Divider,
  Modal,
  Row,
  Col,
  Form,
  Tooltip,
} from "antd";
import { FolderOpenOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import { apiConfig, labelConfig } from "../../../../customer.config";

const DetailedStandingInstruction = (props) => {
  const { currentCustomerObj, userData, standingObj, refreshList } = props;
  const { session } = userData;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [standingInstructionDetail, setStandingInstructionDetail] = useState(
    {}
  );
  const [isLoading, setIsLoading] = useState(false);
  const [inputField, setInputField] = useState([]);
  const [useForm] = Form.useForm();

  useEffect(() => {}, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.standingInstructions}/${standingObj.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        console.log(objDetail);
        setStandingInstructionDetail(objDetail);
        setIsLoading(false);

        setInputField([
          {
            name: labelConfig.name,
            value: objDetail.name ? objDetail.name : "-",
            type: "general",
          },
          {
            name: labelConfig.applicant,
            value: objDetail?.fromClient
              ? objDetail?.fromClient?.displayName
              : "-",
            type: "general",
          },
          {
            name: labelConfig.type,
            value: objDetail?.transferType
              ? objDetail?.transferType?.value
              : "-",
            type: "general",
          },
          {
            name: labelConfig.priority,
            value: objDetail.priority ? objDetail?.priority?.value : "-",
            type: "general",
          },
          {
            name: labelConfig.status,
            value: objDetail.status ? objDetail?.status?.value : "-",
            type: "general",
          },
          {
            name: labelConfig.fromAccountType,
            value: objDetail.fromAccountType
              ? objDetail?.fromAccountType?.value
              : "-",
            type: "general",
          },
          {
            name: labelConfig.fromAccount,
            value: objDetail.fromAccount
              ? objDetail?.fromAccount?.productName
              : "-",
            type: "general",
          },
          {
            name: labelConfig.destination,
            value:
              objDetail.fromClient.id === objDetail.toClient.id
                ? "Own Bank"
                : "Within Bank",
            type: "beneficiary",
          },
          {
            name: labelConfig.toBranch,
            value: objDetail.toOffice ? objDetail?.toOffice?.name : "-",
            type: "beneficiary",
          },
          {
            name: labelConfig.beneficiary,
            value: objDetail.toClient ? objDetail?.toClient?.displayName : "-",
            type: "beneficiary",
          },
          {
            name: labelConfig.toAccountType,
            value: objDetail.toAccountType
              ? objDetail?.toAccountType?.value
              : "-",
            type: "beneficiary",
          },
          {
            name: labelConfig.toAccount,
            value: objDetail.toAccount
              ? objDetail?.toAccount?.productName
              : "-",
            type: "beneficiary",
          },
          {
            name: labelConfig.standingInstructionType,
            value: objDetail.instructionType
              ? objDetail?.instructionType?.value
              : "-",
            type: "instruction",
          },
          {
            name: labelConfig.amount,
            value: objDetail.amount ? objDetail.amount : "-",
            type: "instruction",
          },
          {
            name: labelConfig.validityFrom,
            value: BOM.DateTime(objDetail.validFrom, "only-date"),
            type: "instruction",
          },
          {
            name: labelConfig.to,
            value: objDetail.validTill
              ? BOM.DateTime(objDetail.validTill, "only-date")
              : "No-Date",
            type: "instruction",
          },
          {
            name: labelConfig.recurrenceType,
            value: objDetail.recurrenceType
              ? objDetail?.recurrenceType?.value
              : "-",
            type: "instruction",
          },
          {
            name: labelConfig.interval,
            value: objDetail.recurrenceInterval
              ? objDetail.recurrenceInterval
              : "-",
            type: "instruction",
          },
          {
            name: labelConfig.recurrenceFrequency,
            value: objDetail.recurrenceFrequency
              ? objDetail?.recurrenceFrequency?.value
              : "-",
            type: "instruction",
          },
          {
            name: labelConfig.onMonthDay,
            value: BOM.DateTimeWithoutYear(
              objDetail.recurrenceOnMonthDay,
              "only-date"
            ),
            type: "instruction",
          },
        ]);
        // ENABLE DELETE BUTTON
        // dispatch({
        //   type: cnt.RIGHT_DELETE_BTN,
        // });
        setIsLoading(false);
      }
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    getDetailById();
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOnClose = () => {
    let action = "Close  ";
    let label = standingInstructionDetail.name;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${apiConfig.standingInstructions}/${standingInstructionDetail.id}?command=delete`;

        const body = {
          method: "PUT",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteStandingInstructionMsg);
            // close modal
            setIsModalOpen(false);

            //refresh the list
            refreshList();

            //STOP LOAD
            setIsLoading(false);
          }
        });
      },
      function () {
        // No button
      }
    );
  };

  return (
    <>
      <Tooltip title={`View Detail`}>
        <Button
          type="primary"
          icon={<FolderOpenOutlined />}
          onClick={showModal}
          shape="round"
          size="small"
          className="of-primaryBtnColor"
        />
      </Tooltip>
      <Modal
        title="Standing Instruction Detail"
        centered
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Form layout="vertical" form={useForm}>
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Space size="small">
                {BOM.HasPermission("DELETE_STANDINGINSTRUCTION") && (
                  <Button
                    type="primary"
                    shape="round"
                    className="of-primaryBtnColor"
                    onClick={() => handleOnClose()}
                    disabled={
                      !(standingInstructionDetail?.status?.value !== "Deleted")
                    }
                    danger={
                      standingInstructionDetail?.status?.value !== "Deleted"
                        ? true
                        : false
                    }
                  >
                    {`${
                      standingInstructionDetail?.status?.value !== "Deleted"
                        ? labelConfig.close
                        : labelConfig.closed
                    }`}
                  </Button>
                )}
              </Space>
            </div>
            <Row>
              <Divider orientation="left">{labelConfig.generalInfo}</Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "general" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input
                          disabled
                          value={item.value}
                          className="of-bold-disable-input"
                        />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>

            <Row>
              <Divider orientation="left">
                {labelConfig.beneficiaryInfo}
              </Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "beneficiary" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input
                          disabled
                          value={item.value}
                          className="of-bold-disable-input"
                        />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>
            <Row>
              <Divider orientation="left">
                {labelConfig.instructionInfo}
              </Divider>
              {inputField.map(
                (item, index) =>
                  item?.type?.toLowerCase() === "instruction" && (
                    <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={item.name}>
                        <Input
                          disabled
                          value={item.value}
                          className="of-bold-disable-input"
                        />
                      </Form.Item>
                    </Col>
                  )
              )}
            </Row>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

export default DetailedStandingInstruction;
